import React, { useCallback } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps, useNavigate } from 'react-router-dom';

/**
 * Wrapper around react router link that automatically handles service worker updates
 * See https://zach.codes/handling-client-side-app-updates-with-service-workers/
 */

type LinkProps = {
  onClick?: () => void;
} & RouterLinkProps;

export default function Link({ onClick, to, ...otherProps }: LinkProps) {
  const navigate = useNavigate();
  const handleClick = useCallback(
    (e: any) => {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      // @ts-ignore
      if (window.swUpdate) {
        // @ts-ignore
        window.location = to;
      }
      if (onClick) {
        onClick(e);
      }
      navigate(to);
    },
    [to, navigate, onClick],
  );

  return <RouterLink to={to} onClick={handleClick} {...otherProps} />;
}
Link.defaultProps = {
  onClick: () => {},
};
